import {
  Robot,
  CurrencyDollar,
  Gear,
  ChartBar,
  Database,
  FileText,
  GlobeHemisphereWest,
  ShieldCheck,
  UsersThree,
  Buildings,
  Recycle,
  Tree,
  Car,
  Books,
  HardHat,
  Smiley,
  Leaf,
  Train,
  ChartPie,
  LockSimple,
  House,
  MapPin,
  Calendar,
  Info,
  Warning,
  CheckCircle,
  Eye,
  Plugs,
  Star,
  TrendUp,
  Factory,
  Bell,
  ListChecks,
  Clock,
  Table,
  User,
  EnvelopeSimple,
  RoadHorizon,
  Truck,
  CalendarBlank,
  CreditCard,
  SmileyWink,
  Lightning,
  Cloud,
  Drop,
  Trophy,
  Wallet,
} from "@phosphor-icons/react";

export const iconMap: Record<string, React.ElementType> = {
  // Agent icons (from backend)
  ChatBot: Robot,
  Money: CurrencyDollar,
  Settings: Gear,
  BarChart4: ChartBar,
  BarChartVertical: ChartBar,
  Database: Database,
  ReportDocument: FileText,
  Globe: GlobeHemisphereWest,
  Shield: ShieldCheck,
  People: UsersThree,
  CityNext: Buildings,
  RecycleBin: Recycle,
  Sunny: Tree,
  Park: Tree,
  Car: Car,
  Library: Books,
  ConstructionCone: HardHat,
  ContactHeart: Smiley,
  Leaf: Leaf,
  Train: Train,
  Home: House,
  ChartPie: ChartPie,
  Lock: LockSimple,
  LockSolid: LockSimple,
  MapPin: MapPin,
  Calendar: Calendar,
  Info: Info,
  Warning: Warning,
  Completed: CheckCircle,
  CheckMark: CheckCircle,
  View: Eye,
  PlugConnected: Plugs,
  FavoriteStar: Star,
  TimelineProgress: TrendUp,
  Manufacturing: Factory,
  Ringer: Bell,
  TaskManager: ListChecks,
  Clock: Clock,
  Table: Table,
  Contact: User,
  Mail: EnvelopeSimple,
  Delete: Recycle,
  Up: TrendUp,
  Group: UsersThree,
  Education: Books,
  NumberedList: ListChecks,
  Sync: Recycle,
  Running: UsersThree,
  Trophy: Star,
  Road: RoadHorizon,
  DeliveryTruck: Truck,
  Event: CalendarBlank,
  PaymentCard: CreditCard,
  Emoji2: SmileyWink,
  LightningBolt: Lightning,
  Cloud: Cloud,
  Drop: Drop,
  Trophy2: Trophy,
  DateTime: Clock,
  Wallet: Wallet,
};

export function getPhosphorIcon(fluentName: string): React.ElementType {
  return iconMap[fluentName] || Robot;
}
